import { gql } from '@apollo/client';

import { FINANCIAL_ACCOUNT_FRAGMENT } from '../../hooks/queries/useFinancialAccounts';

/**
 * Plaid account-linking GraphQL operations, shared by every entry point into
 * the link flow — the onboarding/settings `PlaidLinkButton` and the assistant's
 * `financial_account_connect` client tool. They live here, not inline in one
 * component, because GraphQL operation names must be unique across the app: two
 * components each declaring `mutation CreateLinkToken` would collide at codegen.
 * One definition, imported wherever the flow runs.
 */

export const CREATE_LINK_TOKEN = gql`
  mutation CreateLinkToken($input: CreateLinkTokenInput!) {
    createLinkToken(input: $input) {
      linkToken
    }
  }
`;

export const EXCHANGE_PUBLIC_TOKEN = gql`
  mutation ExchangePublicToken($input: ExchangePublicTokenInput!) {
    exchangePublicToken(input: $input) {
      ...FinancialAccountFields
    }
  }
  ${FINANCIAL_ACCOUNT_FRAGMENT}
`;

export const CREATE_FINANCIAL_ACCOUNTS = gql`
  mutation CreateFinancialAccounts($input: CreateFinancialAccountsInput!) {
    createFinancialAccounts(input: $input) {
      ...FinancialAccountFields
    }
  }
  ${FINANCIAL_ACCOUNT_FRAGMENT}
`;

export const DISMISS_BANK_CONNECTION_CALLOUT = gql`
  mutation DismissBankConnectionCallout($bankConnectionId: String!) {
    dismissBankConnectionCallout(bankConnectionId: $bankConnectionId)
  }
`;
